<!--
 * @Author: lsqbeyond lsqbeyond@yeah.net
 * @Date: 2025-09-21 20:08:48
 * @LastEditors: lsqbeyond lsqbeyond@yeah.net
 * @LastEditTime: 2025-10-12 23:26:55
 * @FilePath: \tracenew\src\components\OnlineService.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="online-service" :class="{ 'collapsed': isCollapsed }">
    <!-- 展开/收缩按钮 -->
    <div class="toggle-btn" @click="toggleService">
      <img :src="isCollapsed ? require('@/assets/images/左箭头.png') : require('@/assets/images/右箭头.png')"  style="height:16px;width:16px">
    </div>
    
    <!-- 服务内容面板 -->
    <div class="service-panel" v-show="!isCollapsed">
      <!-- 标题 -->
      <div class="service-header">
        <span class="service-title">在线客服</span>
      </div>
      
      <!-- QQ客服列表 -->
      <div class="service-content">
        <div class="qq-service-item" v-for="(qq, index) in qqServices" :key="index" @click="openQQChat(qq.number)">
          <div class="qq-avatar">
            <img src="@/assets/images/QQ.png" alt="QQ" class="qq-icon">
          </div>
          <span class="qq-text">{{ qq.name }}</span>
        </div>
        
        <!-- 热线电话 -->
        <div class="phone-section">
          <div class="phone-title">热线电话</div>
          <div class="phone-number" v-for="(phone, index) in phoneNumbers" :key="index" @click="callPhone(phone)">
            {{ phone }}
          </div>
        </div>
        
        <!-- 微信二维码 -->
        <div class="wechat-section">
          <div class="qr-code">
            <img src="@/assets/images/640.webp" alt="微信二维码" class="qr-image">
          </div>
          <div class="wechat-text">微信公众账号</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnlineService',
  data() {
    return {
      isCollapsed: false,
      qqServices: [
        { name: '在线客服1号', number: '2892489300' },
        { name: '在线客服2号', number: '2557556908' },
      ],
      phoneNumbers: [
        '13120454865',
        '18600895993',
      ]
    }
  },
  methods: {
    toggleService() {
      this.isCollapsed = !this.isCollapsed
    },
    openQQChat(qqNumber) {
      // 打开QQ临时对话
      const qqUrl = `https://wpa.qq.com/msgrd?v=3&uin=${qqNumber}&site=qq&menu=yes`
      window.open(qqUrl, '_blank')
    },
    callPhone(phoneNumber) {
      // 拨打电话
      window.location.href = `tel:${phoneNumber}`
    }
  }
}
</script>

<style scoped>
.online-service {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9999;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  transition: all 0.3s ease;
}

.online-service.collapsed {
  /* right: -180px; */
}

.toggle-btn {
  position: absolute;
  left: -23px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 48px;
  background: linear-gradient(135deg, #f5a623, #ff8c00);
  border-radius: 8px 0 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.toggle-btn:hover {
  background: linear-gradient(135deg, #ff8c00, #f5a623);
  box-shadow: -3px 0 12px rgba(0, 0, 0, 0.3);
}

.arrow-icon {
  color: white;
  font-size: 16px;
  font-weight: bold;
  transition: transform 0.3s ease;
  transform: rotate(180deg);
}

.arrow-icon.collapsed {
  transform: rotate(0deg);
}

.service-panel {
  width: 163px;
  background: white;
  border-radius: 8px 0 0 8px;
  box-shadow: -5px 0 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.service-header {
  background: linear-gradient(135deg, #f5a623, #ff8c00);
  padding: 15px 20px;
  text-align: center;
}

.service-title {
  color: white;
  font-size: 16px;
  font-weight: bold;
}

.service-content {
  padding: 10px 20px 20px 20px;
}

.qq-service-item {
  display: flex;
  align-items: center;
  padding: 6px 0;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid #f0f0f0;
}

.qq-service-item:hover {
  background-color: #f8f9fa;
  /* padding-left: 5px; */
}

.qq-service-item:last-of-type {
  border-bottom: none;
}

.qq-avatar {
  width: 32px;
  height: 32px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qq-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}

.qq-text {
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.phone-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
}

.phone-title {
  color: #333;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
}

.phone-number {
  color: #ff8c00;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  margin: 8px 0;
  cursor: pointer;
  transition: color 0.3s ease;
}

.phone-number:hover {
  color: #f5a623;
  text-decoration: underline;
}

.wechat-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
  text-align: center;
}

.qr-code {
  margin-bottom: 10px;
}

.qr-image {
  width: 120px;
  height: 120px;
  border: 1px solid #e9ecef;
  border-radius: 4px;
}

.wechat-text {
  color: #666;
  font-size: 12px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .online-service {
    right: -10px;
  }
  
  .service-panel {
    width: 260px;
  }
  
  .toggle-btn {
    left: -35px;
    width: 35px;
    height: 70px;
  }
  
  .arrow-icon {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .service-panel {
    width: 240px;
  }
  
  .service-content {
    padding: 15px;
  }
  
  .qr-image {
    width: 100px;
    height: 100px;
  }
}
</style>